import { createTheme } from '@mui/material'

const brettTheme = createTheme({
  palette: {
    background: {
      default: '#f9fafc',
      input: '#f4f6f9',
      paper: '#ffffff',
    },
    primary: {
      light: '#33c9dc',
      main: '#00bcd4',
      dark: '#008394',
    },
  },
})

export default brettTheme
